import { useCallback } from 'react';

import { useTextEditorFieldAiEdit, UseTextEditorFieldAiEditResult } from '~libs.desktop.ai-assistant';

import { VisitField } from '../../../common/visitForm/VisitFormContext.types';
import { useVisitFormContext } from '../../../common/visitForm/VisitFormContext';

type UseVisitFormAiEditOptions = {
   field: VisitField;
};

export const useVisitFormAiEdit = (options: UseVisitFormAiEditOptions): UseTextEditorFieldAiEditResult => {
   const { getFieldHtml, setFieldHtml } = useVisitFormContext();

   const getHtml = useCallback(() => getFieldHtml(options.field), [getFieldHtml, options.field]);

   const setHtml = useCallback((html: string) => setFieldHtml(options.field, html), [setFieldHtml, options.field]);

   return useTextEditorFieldAiEdit({ field: options.field, getHtml: getHtml, setHtml: setHtml });
};
